import React, {StrictMode} from 'react';
import {render} from 'react-dom';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
// import Home from './views/Home';
import 'antd/dist/antd.css';
import ImageToHex from './views/ImageToHex';
// import DownloadPage from './views/DownloadPage';
// import ChipIDQuery from './views/ChipIDQuery';

render(
  <App />,
  document.getElementById('root')
);

function App() {
  return(
    <StrictMode>
      <BrowserRouter>
        <Switch>
          {/* <Route exact path='/' component={Home}/> */}
          <Route exact path='/image-to-hex' component={ImageToHex}/>
          {/* <Route exact path='/download' component={DownloadPage}/> */}
          {/* <Route exact path='/search' component={ChipIDQuery}/> */}
        </Switch>
      </BrowserRouter>
    </StrictMode>
  );
}